import { render } from "./PartnersHomeView.vue?vue&type=template&id=eca3be6e"
import script from "./PartnersHomeView.vue?vue&type=script&lang=js"
export * from "./PartnersHomeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__